var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"settingsApp"}},[_c('Tabs',{attrs:{"vertical":_vm.vertical}},[_c('Tab',{attrs:{"label":_vm.$t('general.settings'),"to":"/settings/onboarding"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }